import React, { useState, useEffect } from 'react';
import {
    ColumnProps, GridView, SimpleView, Table, Widget, Row,
    FormInput, Col, FormResetButton, Form, Button
} from '@digital/ui';
import {
    getRelatorioConsolidadoPlurianualADistribuirMenorQueZero,
    ConsolidadoPluriAnualRelatorioADistribuirResult,
    getAllVerificarPluriAnualDiferenteDeZero,
    exportarVerificarPluriAnualDiferenteDeZero,
    exportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero
} from '@app/api/crf/consolidadoPluriAnual';

import { Collapse, Icon } from 'antd';
import { compareText } from '@app/helpers/comparators';

const { Panel } = Collapse;

const CrfVerificacaoDeErros = () => {

    const [result, setResult] = useState([] as ConsolidadoPluriAnualRelatorioADistribuirResult[]);
    const [resultVerificacaoPluriAnual, setResultVerificacaoPluriAnual] = useState([] as ConsolidadoPluriAnualRelatorioADistribuirResult[]);

    useEffect(() => {
        GetAll();
    }, []);

    const GetAll = () => {
        getRelatorioConsolidadoPlurianualADistribuirMenorQueZero().then((data: any) => {
            if (data && Array.isArray(data)) {

                data.forEach((item, indice, array) => {
                    indice++;
                    item.numeroLinha = indice;
                });

                setResult(data);
            }
        });

        getAllVerificarPluriAnualDiferenteDeZero().then((data: any) => {
            if (data && Array.isArray(data)) {

                data.forEach((item, indice, array) => {
                    indice++;
                    item.numeroLinha = indice;
                });

                setResultVerificacaoPluriAnual(data);
            }
        });
    }


    const getAllColluns = (verificacao: boolean) => {
        let colluns: ColumnProps<ConsolidadoPluriAnualRelatorioADistribuirResult>[] = new Array();

        colluns.push(
            {
                title: 'N',
                dataIndex: 'numeroLinha',
            });


        colluns.push(
            {
                title: 'Cód. Projeto',
                dataIndex: 'projetoCodigo',
                sorter: (a, b) => compareText(a.projetoCodigo, b.projetoCodigo),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="projetoCodigo"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.projetoCodigo !== undefined &&
                    record.projetoCodigo
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),

            });

        colluns.push(
            {
                title: 'CÓDIGO',
                dataIndex: 'codigoPacote',
                sorter: (a, b) => compareText(a.codigoPacote, b.codigoPacote),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="codigoPacote"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.codigoPacote !== undefined &&
                    record.codigoPacote
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            });

        colluns.push(
            {
                title: 'NOME PACOTE',
                dataIndex: 'consolidadoPlurianualConsolidadoPlurianualNomePacote',
                sorter: (a, b) => compareText(a.consolidadoPlurianualConsolidadoPlurianualNomePacote, b.consolidadoPlurianualConsolidadoPlurianualNomePacote),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="consolidadoPlurianualConsolidadoPlurianualNomePacote"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.consolidadoPlurianualConsolidadoPlurianualNomePacote !== undefined &&
                    record.consolidadoPlurianualConsolidadoPlurianualNomePacote
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            });


        colluns.push(
            {
                title: `${verificacao ? 'VERIFICAÇÃO PLURIANUAL' : 'COMPROMISSADO'}`,
                dataIndex: 'valorFormatado'
            });


        colluns.push(
            {
                title: `Executado`,
                dataIndex: 'executadoFormatado'
            }
        );

        colluns.push(
            {
                title: `EXECUTADO NOS ANOS ANTERIORES`,
                dataIndex: 'executadoAnosAnterioFormatado'
            }
        );



        return colluns;
    }





    const hasExpostarRelatorio = (verificacao: boolean) => {

        if (verificacao) {
            exportarVerificarPluriAnualDiferenteDeZero('RELATÓRIOPROJETOSVERIFICAÇÃOPLURIANULDIFERENTEDEZERO.xlsx')
        } else {
            exportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero('RELATÓRIOPROJETOSCOMPROMISSADONEGATIVOS.xlsx')
        }
    }

    return (
        <>
            <SimpleView >
                <GridView noform>
                    <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                        <Panel key="1" header="Relatório PROJETOS COMPROMISSADO NEGATIVOS" style={{ border: 0 }}>
                            <Widget actions={
                                [
                                    <Button
                                        type="primary"
                                        size={'small'}
                                        icon="files-ms_excel"
                                        onClick={() => {
                                            hasExpostarRelatorio(false);
                                        }}
                                    >
                                        Exporta para Excel
                                    </Button>
                                ]}>
                                <Table
                                    columns={getAllColluns(false)}
                                    dataSource={result}
                                    pagination={{
                                        pageSize: 10,
                                    }}
                                />
                            </Widget>
                        </Panel>
                    </Collapse>
                    <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                        <Panel key="1" header="Relatório PROJETOS VERIFICAÇÃO PLURIANUL DIFERENTE DE ZERO" style={{ border: 0 }}>
                            <Widget actions={
                                [
                                    <Button
                                        type="primary"
                                        size={'small'}
                                        icon="files-ms_excel"
                                        onClick={() => {
                                            hasExpostarRelatorio(true);
                                        }}
                                    >
                                        Exporta para Excel
                                    </Button>
                                ]}>
                                <Table
                                    columns={getAllColluns(true)}
                                    dataSource={resultVerificacaoPluriAnual}
                                    pagination={{
                                        pageSize: 10,
                                    }}
                                />
                            </Widget>
                        </Panel>
                    </Collapse>
                </GridView>
            </SimpleView>



        </>);
}


export default CrfVerificacaoDeErros;

